export default __webpack_public_path__ + "static/media/rocket_anim_100.7152e21f.png";